import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryGrid from './components/CategoryGrid';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '麻豆cm传媒在线高清',
  url: 'https://madoucm.com/',
  description: '麻豆cm传媒在线高清为您提供最新高清视频内容，画质清晰流畅，海量资源免费在线观看，支持多终端播放，随时随地享受极致高清视听体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://madoucm.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '麻豆cm传媒在线高清平台是否需要付费？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '麻豆cm传媒在线高清平台提供大量免费高清视频内容，用户注册后即可免费在线观看。部分独家内容可能需要VIP会员权限，但核心资源库对全体用户开放。',
      },
    },
    {
      '@type': 'Question',
      name: '支持哪些设备观看高清视频？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们的平台支持多终端播放，包括电脑、平板和手机。只需一个账号，即可在不同设备间无缝切换。',
      },
    },
    {
      '@type': 'Question',
      name: '视频画质最高支持多少分辨率？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '麻豆cm传媒平台最高支持4K超高清分辨率播放，同时提供1080P、720P等多种画质选项，系统会根据网络状况自动调整最佳画质。',
      },
    },
  ],
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <title>麻豆cm传媒在线高清 - 官方正版高清视频平台</title>
      <meta name="description" content="麻豆cm传媒在线高清为您提供最新高清视频内容，画质清晰流畅，海量资源免费在线观看，支持多终端播放，随时随地享受极致高清视听体验，立即访问麻豆cm传媒在线高清官方平台。" />
      <meta name="keywords" content="麻豆cm传媒在线高清,麻豆传媒高清视频,麻豆cm在线播放,麻豆传媒最新视频,麻豆cm高清免费观看,麻豆传媒官方平台,麻豆cm传媒视频合集" />
      <link rel="canonical" href="https://madoucm.com/" />
      <meta property="og:title" content="麻豆cm传媒在线高清 - 官方正版高清视频平台" />
      <meta property="og:description" content="麻豆cm传媒在线高清为您提供最新高清视频内容，画质清晰流畅，海量资源免费在线观看，支持多终端播放，随时随地享受极致高清视听体验。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://madoucm.com/" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="麻豆cm传媒在线高清 - 官方正版高清视频平台" />
      <meta name="twitter:description" content="麻豆cm传媒在线高清为您提供最新高清视频内容，画质清晰流畅，海量资源免费在线观看。" />
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategoryGrid />
        <LatestSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}